import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import { MISSION_INFO } from "@/lib/constants";

const ORDER = ["marriage", "dating", "flirtation"];

export function StepMission({ value, onChange, error }) {
  // Mission names, descriptions, button labels and availability are admin-configurable
  const { data } = useQuery({ queryKey: ["options"], queryFn: () => api("/options", { auth: false }) });
  const cats = data?.mission_categories;
  const order = ORDER.filter((m) => !cats || cats[m]?.enabled !== false || value === m);
  return (
    <div data-testid="wizard-step-mission">
      <h1 className="text-[34px] leading-tight">What are you looking for on LOVE NET?</h1>
      <p className="mb-6 mt-1 text-sm text-muted-foreground">Pick one mission. It sets the kind of request you send to members.</p>
      <div className="flex flex-col gap-3" role="radiogroup" aria-label="Mission">
        {order.map((m, i) => {
          const c = cats?.[m];
          const info = { ...MISSION_INFO[m], ...(c ? { label: c.display_name, text: c.description, button: c.button_label } : {}) };
          const on = value === m;
          const Icon = MISSION_INFO[m].Icon;
          return (
            <button key={m} type="button" role="radio" aria-checked={on} data-testid={`mission-card-${m}`} onClick={() => onChange(m)} style={{ animationDelay: `${i * 80}ms` }}
              className={`fade-up flex items-center gap-4 rounded-[20px] border-2 bg-white p-5 text-left transition-all hover:shadow-md active:scale-[0.99] ${on ? "border-primary shadow-md" : "border-border"}`}>
              <span className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-full ${on ? "bg-primary text-white" : "bg-[#F6E3E4] text-primary"}`}><Icon className="h-6 w-6" /></span>
              <span className="flex-1">
                <span className="block font-display text-2xl">{info.label}</span>
                <span className="mt-0.5 block text-sm text-muted-foreground">{info.text}</span>
                <span className="mt-1.5 block text-xs font-bold text-primary">Your button: {info.button}</span>
              </span>
              <span data-testid={`mission-select-${m}`} className={`rounded-full px-4 py-2 text-xs font-bold ${on ? "bg-primary text-white" : "border border-primary text-primary"}`}>{on ? "Selected" : "Select"}</span>
            </button>
          );
        })}
      </div>
      {error ? <p className="mt-3 text-sm font-medium text-[#9E3C3E]">{error}</p> : null}
    </div>
  );
}
